const imageWithPattern = Array.from(
  document.querySelectorAll(".image-with-pattern")
);

/**
 * @description - Function checks if element is in the viewport and adds appropriate class to it.
 */
const showImageWhenInViewport = function(item) {
  const show = debounce(item => {
    if (item && isInViewport(item)) {
      item.classList.add("in-viewport");
    }
  }, 30);
  show(item);
};

/**
 * Initialize functions on start and on scroll
 */
window.addEventListener("scroll", () => {
  imageWithPattern.forEach(item => {
    showImageWhenInViewport(item);
  });
});

imageWithPattern.forEach(item => {
  showImageWhenInViewport(item);
});
